import * as type from '../../../actions/index.types'

export function CtrlLocationReducers(state = {
    loading: false,
    createLoading: false,
    detailsLoading: false,
    countryData: null,
    countryDetails: null,
    stateData: null,
    stateDetails: null,
    cityLoading: false,
    cityData: null,
    cityDetails: null,
    error: null
}, action) {

    switch (action.type) {
        case type.CTRL_GET_COUNTRY:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.CTRL_GET_COUNTRY_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                countryData: action.payload,
            }
        }
        case type.CTRL_GET_COUNTRY_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        case type.CTRL_GET_COUNTRY_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                error: null,
            }
        case type.CTRL_GET_COUNTRY_DETAILS_SUCCESS: {
            return {
                ...state,
                error: null,
                detailsLoading: false,
                countryDetails: action.payload,
            }
        }
        case type.CTRL_GET_COUNTRY_DETAILS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                detailsLoading: false,
            }

        case type.CTRL_CREATE_COUNTRY:
            return {
                ...state,
                createLoading: true,
                error: null,
            }
        case type.CTRL_CREATE_COUNTRY_SUCCESS: {
            return {
                ...state,
                error: null,
                createLoading: false,
            }
        }
        case type.CTRL_CREATE_COUNTRY_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createLoading: false,
            }

        case type.CTRL_EDIT_COUNTRY:
            return {
                ...state,
                detailsLoading: true,
                error: null,
            }
        case type.CTRL_EDIT_COUNTRY_SUCCESS: {
            return {
                ...state,
                error: null,
                detailsLoading: false,
                countryDetails: action.payload,
            }
        }
        case type.CTRL_EDIT_COUNTRY_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                detailsLoading: false,
            }

        case type.CTRL_DELETE_COUNTRY:
            return {
                ...state,
                error: null,
            }
        case type.CTRL_DELETE_COUNTRY_SUCCESS: {
            return {
                ...state,
                error: null,
            }
        }
        case type.CTRL_DELETE_COUNTRY_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
            }

        case type.CTRL_GET_STATE:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.CTRL_GET_STATE_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                stateData: action.payload,
            }
        }
        case type.CTRL_GET_STATE_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        case type.CTRL_GET_STATE_DETAILS:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.CTRL_GET_STATE_DETAILS_SUCCESS: {
            return {
                ...state,
                error: null,
                loading: false,
                stateDetails: action.payload,
            }
        }
        case type.CTRL_GET_STATE_DETAILS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        case type.CTRL_CREATE_STATE:
            return {
                ...state,
                createLoading: true,
                error: null,
            }
        case type.CTRL_CREATE_STATE_SUCCESS: {
            return {
                ...state,
                error: null,
                createLoading: false,
            }
        }
        case type.CTRL_CREATE_STATE_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createLoading: false,
            }

        case type.CTRL_EDIT_STATE:
            return {
                ...state,
                detailsLoading: true,
                error: null,
            }
        case type.CTRL_EDIT_STATE_SUCCESS: {
            return {
                ...state,
                error: null,
                detailsLoading: false,
            }
        }
        case type.CTRL_EDIT_STATE_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                detailsLoading: false,
            }

        case type.CTRL_DELETE_STATE:
            return {
                ...state,
                error: null,
            }
        case type.CTRL_DELETE_STATE_SUCCESS: {
            return {
                ...state,
                error: null,
            }
        }
        case type.CTRL_DELETE_STATE_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
            }



        /* =========================
GET CITY
========================= */
        case type.CTRL_GET_CITY:
            return {
                ...state,
                cityLoading: true,
                error: null,
            };

        case type.CTRL_GET_CITY_SUCCESS:
            return {
                ...state,
                error: null,
                cityLoading: false,
                cityData: action.payload,
            };

        case type.CTRL_GET_CITY_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                cityLoading: false,
            };

        /* =========================
           GET CITY DETAILS
        ========================= */
        case type.CTRL_GET_CITY_DETAILS:
            return {
                ...state,
                detailsLoading: true,
                error: null,
            };

        case type.CTRL_GET_CITY_DETAILS_SUCCESS:
            return {
                ...state,
                error: null,
                detailsLoading: false,
                cityDetails: action.payload,
            };

        case type.CTRL_GET_CITY_DETAILS_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                detailsLoading: false,
            };

        /* =========================
           CREATE CITY
        ========================= */
        case type.CTRL_CREATE_CITY:
            return {
                ...state,
                createLoading: true,
                error: null,
            };

        case type.CTRL_CREATE_CITY_SUCCESS:
            return {
                ...state,
                error: null,
                createLoading: false,
            };

        case type.CTRL_CREATE_CITY_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                createLoading: false,
            };

        /* =========================
           EDIT CITY
        ========================= */
        case type.CTRL_EDIT_CITY:
            return {
                ...state,
                detailsLoading: true,
                error: null,
            };

        case type.CTRL_EDIT_CITY_SUCCESS:
            return {
                ...state,
                error: null,
                detailsLoading: false,
            };

        case type.CTRL_EDIT_CITY_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                detailsLoading: false,
            };

        /* =========================
           DELETE CITY
        ========================= */
        case type.CTRL_DELETE_CITY:
            return {
                ...state,
                error: null,
            };

        case type.CTRL_DELETE_CITY_SUCCESS:
            return {
                ...state,
                error: null,
            };

        case type.CTRL_DELETE_CITY_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
            };

        default:
            return state
    }
}